module.exports = __webpack_public_path__ + "static/sefastone-mockup-8cda917682a2753a8c00108b838efb44.png";